import React from "react";
import Moment from "react-moment";
import "moment-timezone";
import { FaUserAlt } from "react-icons/fa";

const AnuncioComentario = ({ comentario }) => {
  return (
    <article class="py-6 px-3 mb-3 text-base  border-b border-gray-200 w-full  ">
      <footer class="flex justify-between items-center mb-2">
        <div class="flex items-center">
          <p class="inline-flex items-center mr-3 text-sm text-gray-900  font-semibold">
            {comentario.autor.foto ?  <img
              class="mr-2 w-6 h-6 rounded-full"
              src={comentario.autor.foto.url}
              alt="Bonnie Green"
            />  : <div className=" p-1 mr-2 rounded-full bg-blue-50"><FaUserAlt  className=" w-5 h-5 text-blue-700  rounded-md"/></div>}
            {comentario.autor?.name}
          </p>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            <time pubdate datetime="2022-03-12" title="March 12th, 2022">
              {" "}
              <Moment fromNow>{comentario.createdAt}</Moment>
            </time>
          </p>
        </div>
      </footer>
      <p class="text-gray-500 ">
        {comentario.content}
      </p>
      {/* <div class="flex items-center mt-4 space-x-4">
        <button
          type="button"
          class="flex items-center text-sm text-gray-500 hover:underline  font-medium"
        >
          <svg
            class="mr-1.5 w-3.5 h-3.5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 18"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 5h5M5 8h2m6-3h2m-5 3h6m2-7H2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3v5l5-5h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Z"
            />
          </svg>
          Reply
        </button>
      </div> */}
    </article>
  );
};

export default AnuncioComentario;
